import { Component } from '@angular/core';
import { BaseModalComponent } from '../base-modal.component';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-document-info-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './document-info-modal.component.html',
  styleUrl: './document-info-modal.component.scss'
})
export class DocumentInfoModalComponent extends BaseModalComponent {}
